var _path, _path2, _path3, _path4, _path5, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 171,
    viewBox: "0 0 374 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4423 122.926H368.421C369.258 122.926 370.079 123.084 370.804 123.383C371.529 123.682 372.132 124.113 372.553 124.632C372.973 125.15 373.196 125.739 373.2 126.339C373.204 126.939 372.988 127.53 372.574 128.051L339.91 169.218C339.492 169.744 338.888 170.181 338.159 170.485C337.429 170.789 336.601 170.949 335.758 170.95H4.77379C3.93783 170.949 3.11669 170.792 2.39238 170.492C1.66807 170.193 1.06594 169.762 0.646143 169.243C0.226341 168.725 0.0035575 168.136 4.2254e-05 167.536C-0.003473 166.936 0.212403 166.346 0.62611 165.825L33.2897 124.658C33.7064 124.132 34.3104 123.694 35.0399 123.39C35.7695 123.085 36.5985 122.926 37.4423 122.926Z",
    fill: "#EBEDF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.651 136.058C215.651 136.058 138.789 102.055 138.789 67.0017V30.3916C179.978 30.3916 216.081 4.90753 216.081 4.90753C216.081 4.90753 252.076 30.3916 293.113 30.3916V67.0017C293.113 102.069 215.651 136.058 215.651 136.058Z",
    fill: "#770BE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.582 131.161C215.582 131.161 138.735 97.1689 138.735 62.1012V25.4946C179.909 25.4946 216.012 0 216.012 0C216.012 0 251.998 25.4946 293.025 25.4946V62.1012C293.025 97.1689 215.582 131.161 215.582 131.161Z",
    fill: "#8F09F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_30_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 19,
    width: 128,
    height: 92
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M279.371 19.0587H152.517V110.079H279.371V19.0587Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_30_3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_30_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 19,
    width: 128,
    height: 92
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M279.371 19.0587H152.517V110.079H279.371V19.0587Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_30_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.31 29.8483H216.457V34.8189H216.31C239.056 34.8189 257.543 48.1393 257.543 64.4743C257.543 80.8094 239.071 94.1298 216.325 94.1298H216.457V99.1004H216.31C242.877 99.1004 264.49 83.5365 264.49 64.4743C264.49 45.4121 242.877 29.8483 216.31 29.8483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.31 41.4475H216.457V46.4146H216.31C222.861 46.5457 229.083 48.5051 233.653 51.8763C238.222 55.2476 240.778 59.7647 240.778 64.4673C240.778 69.1699 238.222 73.687 233.653 77.0583C229.083 80.4295 222.861 82.389 216.31 82.52H216.442V87.4906H216.295C224.807 87.4906 232.969 85.0646 238.988 80.7462C245.006 76.4278 248.387 70.5709 248.387 64.4638C248.387 58.3567 245.006 52.4998 238.988 48.1814C232.969 43.863 224.807 41.437 216.295 41.437",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.31 53.0433H216.457V58.014H216.31C218.698 58.014 220.988 58.6946 222.677 59.9062C224.365 61.1177 225.314 62.7609 225.314 64.4743C225.314 66.1878 224.365 67.831 222.677 69.0425C220.988 70.2541 218.698 70.9348 216.31 70.9348H216.442V75.9054H216.295C220.521 75.9054 224.573 74.701 227.56 72.5573C230.548 70.4136 232.227 67.506 232.227 64.4743C232.227 61.4427 230.548 58.5351 227.56 56.3914C224.573 54.2477 220.521 53.0433 216.295 53.0433",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1);
export default __webpack_public_path__ + "static/media/f_1.fb760749f2153f2e10bebf2328e35dde.svg";
export { ForwardRef as ReactComponent };